import { render, staticRenderFns } from "./ReportingClient.vue?vue&type=template&id=115fbbfe&"
import script from "./ReportingClient.vue?vue&type=script&lang=js&"
export * from "./ReportingClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports